module.exports = __webpack_public_path__ + "img/VillaLoreto_Resort.507ab73d.jpg";